import React from "react";
import { withRouter } from "react-router";

import "./Button.css";

const button = (props) => {
  return (
    <button
      className={"Button " + props.buttonType + " " + props.size}
      onClick={(event) => {
        window.location.href = props.to;
      }}
    >
      {props.children}
    </button>
  );
};

export default withRouter(button);
